import SectionHeading from "./SectionHeading";
import { privacyPoints } from "@/mocks/home";

export default function PrivacySection() {
  return (
    <section id="privacy" className="w-full bg-background-100 py-16 md:py-24 scroll-mt-20">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-start">
          <div className="lg:col-span-5 flex flex-col gap-6">
            <div className="w-full h-[280px] md:h-[360px] rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=stylized%20abstract%20editorial%20illustration%20of%20a%20protective%20shield%20made%20of%20folded%20paper%20sheltering%20a%20small%20glowing%20lamp%2C%20warm%20amber%20and%20deep%20crimson%20tones%20on%20cream%20paper%20background%2C%20minimal%20artistic%20composition%2C%20soft%20grain%20texture%2C%20calm%20and%20trustworthy%20mood&width=900&height=1100&seq=baoliao-privacy-01&orientation=portrait"
                alt="以纸张折叠成的护盾守护一盏小灯，象征投稿人隐私保护机制"
                title="爆料投稿隐私保护机制"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="p-6 rounded-lg bg-background-50 border border-background-200">
              <h3 className="font-heading font-bold text-lg text-foreground-950 flex items-center gap-2">
                <i className="ri-parentheses-line text-primary-600"></i>
                匿名保护等级
              </h3>
              <ul className="mt-4 space-y-3 text-sm">
                <li className="flex items-start gap-3 text-foreground-700">
                  <span className="shrink-0 px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-800 text-xs">基础</span>
                  对外匿名，编辑内部可见联系方式
                </li>
                <li className="flex items-start gap-3 text-foreground-700">
                  <span className="shrink-0 px-2 py-0.5 rounded-full bg-primary-100 text-primary-800 text-xs">加强</span>
                  隐去姓名与职务，仅保留核验渠道
                </li>
                <li className="flex items-start gap-3 text-foreground-700">
                  <span className="shrink-0 px-2 py-0.5 rounded-full bg-accent-100 text-accent-800 text-xs">最高</span>
                  专人单线对接，投稿记录可即时删除
                </li>
              </ul>
            </div>
          </div>

          <div className="lg:col-span-7">
            <SectionHeading
              eyebrow="隐私保护"
              title="是否保护投稿人？这是我们最认真对待的一环"
              desc="保护投稿人不是一句口号，而是一整套从存储、审核到发布的流程约束。下面六条是你在投稿前需要了解的具体保障。"
            />

            <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
              {privacyPoints.map((point) => (
                <div
                  key={point.title}
                  className="p-5 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors"
                >
                  <span className="w-10 h-10 rounded-md flex items-center justify-center bg-primary-100 text-primary-700">
                    <i className={`${point.icon} text-xl`}></i>
                  </span>
                  <h3 className="mt-4 font-heading font-bold text-base text-foreground-950">
                    {point.title}
                  </h3>
                  <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{point.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}